module.exports = __webpack_public_path__ + "static/media/Jodie Lesh.3364714d.png";